import React from 'react';
import {PropTypes} from 'prop-types';

import {LocaleMenuItemWrapper} from '@homeaway/react-locale-switcher';

function LocaleSwitcherMenu({localeSwitcher}) {
    function renderItem(item) {
        return (
            <div
                className="site-header-tray__menu-item-link"
                key={item.locale}
            >
                <LocaleMenuItemWrapper
                    locale={item.locale}
                    countryName={item.countryName}
                    languageName={item.languageName}
                    basePath={item.basePath}
                    link={item.link}
                />
            </div>
        );
    }

    return (
        <div className="site-header-tray__menu site-header-tray__drawer">
            <div className="site-header-tray__items">
                {localeSwitcher.locales.map(renderItem)}
            </div>
        </div>
    );
}

LocaleSwitcherMenu.propTypes = {
    localeSwitcher: PropTypes.shape({})
};

export {LocaleSwitcherMenu};
